<p class="testimonial-heading">Somebody like you is happy with ZestMoney</p>
<div class="zest-slick-slider container">
  <div *ngFor="let testimonial of testimonials">
    <div class="testimonial-container">
      <div class="row">
        <div class="col s12">
          <div class="row">
            <div class="col s2"></div>
            <div class="col s2 center">
              <img class="testimonial-img circle responsive-img" [src]="'../../assets/images/testimonials/' + testimonial.photoUrl" />
            </div>
            <div class="col s6 center">
              <div class="row">
                <div class="col s12 testimonial-header-container">
                  <p class="testimonial-header" [textContent]="testimonial.name"></p>
                  <p class="testimonial-subheader" [textContent]="'- ' + testimonial.merchantName"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12 testimonial-content" [textContent]="'“' + testimonial.quote + '“'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>